import { createGlobalStyle } from 'styled-components';
import reset from 'styled-reset';

import '@fontsource-variable/dm-sans';
import '@fontsource/inter';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';

const GlobalStyle = createGlobalStyle`
${reset}

:root {
  --black: rgb(45, 48, 62);
  --white: rgb(255, 255, 255);

  --red: rgb(219, 48, 63);

  --green-light: rgb(234, 252, 248);

  --orange: rgb(240, 142, 50);
  
  --blue-dark: rgb(10, 17, 44);
  --blue-base: rgb(16, 48, 174);
  --blue-light: rgb(5, 127, 206);

  --purple: rgb(108, 84, 255);
  --purple-light: rgb(242, 240, 254);

  --teal-light: rgb(235, 247, 255);
  --teal-dark: rgb(1, 146, 208);
  
  --gray-dark: rgb(96, 98, 109);
  --gray-base: rgb(175, 175, 175);
  --gray-light: rgb(245, 246, 250);
  --gray-medium: rgb(147, 150, 162);
  --gray-border: rgb(220, 223, 232);

  --purple-10: rgb(244, 242, 255);
  --purple-70: rgb(79, 61, 191);

  --sky-10: rgb(235, 247, 255);
  --sky: rgb(5, 127, 206);

  --orange-10: rgb(255, 244, 232);
  --orange-70: rgb(176, 89, 7);

  --grape-10: rgb(250, 242, 255);
  --grape-70: rgb(136, 61, 191);

  --green-10: rgb(234, 252, 248);
  --green-70: rgb(18, 130, 107);

  --blueberry-10: rgb(240, 243, 255);
  --blueberry-70: rgb(7, 32, 128);

  --font-size-sm: 15px;
  --font-size-base: 17px;
  --font-size-lg: 20px;

  --heading-size-xs: 22px;
  --heading-size-sm: 28px;
  --heading-size-base: 38px;
  --heading-size-lg: 44px;
  --heading-size-xl: 50px;
  --heading-size-2xl: 50px;
  --heading-size-3xl: 50px;

  --line-height-base: 1.4;
  --line-height-sm: 1.2;

  --font-weight-base: 400;
  --font-weight-semibold: 600;
  --font-weight-bold: 700;
  --font-weight-black: 800;

  --letter-spacing-base: 0px;
  --letter-spacing-narrow: -0.5px;
  --letter-spacing-wide: 0.5px;
}

@media only screen and (min-width: 47.938rem) {
 :root {
  --heading-size-xl: 50px;
  --heading-size-2xl: 70px;
  --heading-size-3xl: 80px;
 }
}

body, * {
    font-family: "Inter", "Futura PT", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-weight: var(--font-weight-base);
    font-size: var(--font-size-base);
    color: var(--black);
    letter-spacing: var(--letter-spacing-base);
    line-height: 1.5;
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
}

h1, h2, h3, h4, h5, h6 {
  font-family: "DM Sans Variable", "Futura PT", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  color: var(--blue-dark);
}

h1, h2 {
  letter-spacing: var(--letter-spacing-narrow);
}

a, button {
  cursor: pointer;
  text-decoration: none;
}

img {
  image-rendering: -moz-crisp-edges;
  image-rendering: -o-crisp-edges;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  -ms-interpolation-more: nearest-neighbor;
}
`;

export const theme = {
  smallUp: 'only screen',
  mediumUp: `only screen and (min-width: 47.938rem)`,
  largeUp: `only screen and (min-width: 64rem)`,
  xLargeUp: `only screen and (min-width: 87.5rem)`
};

export default GlobalStyle;
